const HamburgerIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <rect opacity="0.2" width="40" height="40" rx="8" fill="white" />
        <path
          d="M29 21H11C10.7348 21 10.4804 20.8946 10.2929 20.7071C10.1054 20.5196 10 20.2652 10 20C10 19.7348 10.1054 19.4804 10.2929 19.2929C10.4804 19.1054 10.7348 19 11 19H29C29.2652 19 29.5196 19.1054 29.7071 19.2929C29.8946 19.4804 30 19.7348 30 20C30 20.2652 29.8946 20.5196 29.7071 20.7071C29.5196 20.8946 29.2652 21 29 21ZM29 14H11C10.7348 14 10.4804 13.8946 10.2929 13.7071C10.1054 13.5196 10 13.2652 10 13C10 12.7348 10.1054 12.4804 10.2929 12.2929C10.4804 12.1054 10.7348 12 11 12H29C29.2652 12 29.5196 12.1054 29.7071 12.2929C29.8946 12.4804 30 12.7348 30 13C30 13.2652 29.8946 13.5196 29.7071 13.7071C29.5196 13.8946 29.2652 14 29 14ZM29 28H11C10.7348 28 10.4804 27.8946 10.2929 27.7071C10.1054 27.5196 10 27.2652 10 27C10 26.7348 10.1054 26.4804 10.2929 26.2929C10.4804 26.1054 10.7348 26 11 26H29C29.2652 26 29.5196 26.1054 29.7071 26.2929C29.8946 26.4804 30 26.7348 30 27C30 27.2652 29.8946 27.5196 29.7071 27.7071C29.5196 27.8946 29.2652 28 29 28Z"
          fill="white"
        />
      </svg>
  );
};
export default HamburgerIcon;
